// Refund policy, shown at checkout (Step 4) and in the confirmation email.
// Source: docs/2027_registration_rules.md → "Refund policy". Plain CommonJS.
const REFUND_POLICY = [
  { item: 'Registration fee', policy: 'Refundable within 48 hours of payment, then non-refundable.' },
  { item: 'Solo and ensemble entries', policy: 'Refundable minus a $20 fee per entry until registration closes.' },
  { item: 'After registration closes', policy: 'No refunds. Injury or illness with a doctor\'s note: credit toward next year.' },
  { item: 'Unused "join a team later" spot', policy: 'If not attached to a team by the time registration closes, it is treated as a withdrawn entry (refund minus $20, or credit).' },
];

const REFUND_CONTACT = 'To request a refund, email info@prixducanada.com with your registration reference.';

module.exports = { REFUND_POLICY, REFUND_CONTACT };
